define.alias("ember-math-helpers/helpers/cos", "preview-grid/helpers/cos");